// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@tps/Overrides/Widgets/Basic/Subscribe";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    ...subscribeStyles.mainGridContainer,
    gap: 22,
};

subscribeStyles.titleGridItem = {
    width: [12, 12, 6, 5, 5],
    css: css`
        flex-direction: column;
    `,
};

subscribeStyles.titleLabel = {
    ...subscribeStyles.titleLabel,
    as: "p",
    css: css`
        margin-bottom: 8px;
    `,
};

subscribeStyles.descriptionText = {
    css: css`
        & > p {
            margin: 0;
            line-height: 17px;
            font-size: 12px;
        }
    `,
};

subscribeStyles.emailGridItem = {
    width: [12, 12, 6, 7, 7],
    css: css`
        align-items: center;
    `,
};

subscribeStyles.emailTextField = {
    cssOverrides: {
        formField: css`
            margin-right: 24px;
            height: 36px;
        `,
    },
};

subscribeStyles.emailButton = {
    css: css`
        width: 150px;
        min-width: 150px;
        margin-right: 12px;
        ${xScreen("lte", "md")} {
            width: 115px;
            min-width: 115px;
        }
    `,
};

subscribeStyles.disclaimerGridItem = {
    width: 12,
    css: css`
        padding: 0 25px 0 0;
        justify-content: flex-end;
    `,
};

subscribeStyles.disclaimerText = {
    size: 12,
    color: "common.ui4",
    css: css`
        & > p {
            margin: 0;
            line-height: 17px;
            font-size: 12px;
            font-style: italic;
        }
    `,
};
